module.exports = __webpack_public_path__ + "img/icon-select-white.9f1ac5cc.svg";